import { useState, createContext, useContext, useCallback } from "react";

const ScoresContext = createContext();
const IncrementContext = createContext();
const DecrementContext = createContext();

/**
 * 各コースのスコアを管理するカスタムフック
 */
const useScores = () => {
  const [frontend, setFrontend] = useState(0);
  const [backend, setBackend] = useState(0);
  const [design, setDesign] = useState(0);
  const [mobile, setMobile] = useState(0);
  const [data, setData] = useState(0);

  const scores = {
    frontend,
    backend,
    design,
    mobile,
    data,
  };

  //文字列を引数にとり、該当するコースのスコアを1増やす
  const increment = useCallback((course) => {
    switch (course) {
      case "frontend":
        setFrontend((value) => value + 1);
        break;
      case "backend":
        setBackend((value) => value + 1);
        break;
      case "design":
        setDesign((value) => value + 1);
        break;
      case "mobile":
        setMobile((value) => value + 1);
        break;
      case "data":
        setData((value) => value + 1);
        break;
      default:
        console.warn("incrementの引数が不正です");
    }
  }, []);

  //文字列を引数にとり、該当するコースのスコアを1減らす
  const decrement = useCallback((course) => {
    switch (course) {
      case "frontend":
        setFrontend((value) => value - 1);
        break;
      case "backend":
        setBackend((value) => value - 1);
        break;
      case "design":
        setDesign((value) => value - 1);
        break;
      case "mobile":
        setMobile((value) => value - 1);
        break;
      case "data":
        setData((value) => value - 1);
        break;
      default:
        console.warn("decrementの引数が不正です");
    }
  }, []);

  return { scores, increment, decrement };
};

export const ScoresProvider = ({ children }) => {
  const { scores, increment, decrement } = useScores();
  return (
    <ScoresContext.Provider value={scores}>
      <IncrementContext.Provider value={increment}>
        <DecrementContext.Provider value={decrement}>
          {children}
        </DecrementContext.Provider>
      </IncrementContext.Provider>
    </ScoresContext.Provider>
  );
};

export const useScoresData = () => {
  return useContext(ScoresContext);
};

export const useIncrement = () => {
  return useContext(IncrementContext);
};

export const useDecrement = () => {
  return useContext(DecrementContext);
};
